<template>
	<div>
<!--		<breadcrumb :routerList="[{to:'/basic/user',title:'系统管理'},{title:'角色管理'}]"/>-->
    <Breadtabsheader/>
		<div class="h-content">
			<div class="h-piece">
					<el-form :inline="true" :model="q" class="demo-form-inline h-formBorder">
						<div class="h-formBox w-formBox">
							<div class="tow-formBox">
								<el-form-item label="角色名称/描述">
									<el-input clearable v-model="q.nameLikedesLike"></el-input>
								</el-form-item>
								<el-form-item label="角色编码">
									<el-input clearable v-model="q.idLike"></el-input>
								</el-form-item>
								<el-form-item label="是否可用">
									<brselect category="shifou_keyong" :v="q.delflag" v-model="q.delflag"></brselect>
								</el-form-item>
							</div>
							<el-form-item>
								<el-button class="h-btn h-formBtn" @click="handleFilter">检索</el-button>
								<el-button class="h-btn h-formBtn h-bggreen" @click="createdict" icon="el-icon-plus" style="width:2rem;">新建角色</el-button>
							</el-form-item>
						</div>

					</el-form>
			</div>
			<div class="h-table h-mrt30">
				<el-table
						ref="ddtable"
						:data="tableData"
						stripe
						border
						style="width: 100%"
				>
					<el-table-column
							prop="name"
							label="名称"
							width="180"
							:show-overflow-tooltip="true">
					</el-table-column>
					<el-table-column
							prop="id"
							label="角色编码"
							width="180"
							:show-overflow-tooltip="true">
					</el-table-column>
					<el-table-column
							prop="delflag"
							label="是否可用"
							width="90">
						<template slot-scope="scope">
							{{scope.row.delflag|dictname('shifou_keyong')}}
						</template>
					</el-table-column>
					<el-table-column
							prop="des"
							label="描述"
							:show-overflow-tooltip="true">
							<template slot-scope="scope">
								<div style="text-align: left;">
									{{scope.row.des}}
								</div>
							</template>
					</el-table-column>
					<el-table-column
							prop="cucode"
							label="创建人id"
							width="110"
							:show-overflow-tooltip="true">
					</el-table-column>
					<el-table-column
							prop="cuname"
							label="创建人"
							width="90"
							:show-overflow-tooltip="true">
					</el-table-column>
					<el-table-column
							prop="cdate"
							label="创建时间"
							width="160"
							:show-overflow-tooltip="true">
					</el-table-column>
					<el-table-column
							prop="lucode"
							label="更新人id"
							width="110">
					</el-table-column>
					<el-table-column
							prop="ldate"
							label="最后更新时间"
							width="160"
							:show-overflow-tooltip="true">
					</el-table-column>
					<el-table-column
							fixed="right"
							label="操作"
							width="120"
					>
						<template slot-scope="scope">
							<el-button
									class="h-tableLink h-btn"
									@click="handleEdit(scope.row)">授权</el-button>
              <template v-if="scope.row.delflag == 1">
                <el-button
                    class="h-tableLink h-btn"
                    @click="handleDelete(scope.row)">删除</el-button>
              </template>
              <template v-if="scope.row.delflag == 0">
                <el-button
                    class="h-tableLink h-btn"
                    @click="handleRecover(scope.row)">恢复</el-button>
              </template>

						</template>
					</el-table-column>
				</el-table>
				<div style="display:flex;justify-content: space-between;flex-direction:row-reverse;margin-top:20px">
					<pagination :page="q" @query="query" />
				</div>
			</div>

			<div>
				<el-dialog :close-on-click-modal="false" :visible.sync="dialogFormVisible" class="h-dialog2">
					<div class="h-dialogImg">
						<div class="h-disTable">
							<div class="h-tableCell">
								<h1>新建角色信息</h1>
							</div>
						</div>
					</div>
					<div class="h-formLine">
						<el-form ref="form" :model="f"
								 :inline="true"  class="demo-ruleForm h-formbLine h-dialogForm">
							<el-form-item label="角色名称" prop="name" :rules="[
                              { required: true, message: '请输入字典名称', trigger: 'blur'},
                            ]" class="h-elformWrap-2">
								<el-input v-model="f.name"></el-input>
							</el-form-item>
							<el-form-item label="角色编码" prop="id" :rules="[
                                          { required: true, message: '请输入字典编码', trigger: 'blur'},
                                        ]" class="h-elformWrap-2">
								<el-input v-model="f.id"></el-input>
							</el-form-item>
							<el-form-item label="描述" class="h-elformWrap-1">
								<el-input :autosize="{ minRows: 2, maxRows: 4}" v-model="f.des"></el-input>
							</el-form-item>
						</el-form>
					</div>
					<div slot="footer" class="dialog-footer">
						<el-button class="h-btn h-formBtn h-bgwhite" @click="dialogFormVisible = false">取 消</el-button>
						<el-button class="h-btn h-formBtn h-bgblue2" @click="save">提交保存</el-button>
					</div>
				</el-dialog>
			</div>
		</div>
	</div>
</template>
<script>
    import ss from '../../api/SystemService'
    export default {
        components: {},
        data() {
            return {
                //查询属性
                q: {
                    nameLikedesLike:null,
                    idLike:null,
                    cdate:null,
					          delflag:1,
                    pageSize:20,
                    pageNo:1,
                    total:0,
                },
                //表单
                f:{
                    id:null,
                    name:null,
                    des:null,
                },
                //table列表
                tableData: [],
                //操作标志
                optflag:'save',
                //弹出框
                dialogFormVisible: false,
            }
        },
        created() {
            this.query();
        },
        methods: {
            query(p) {
                ss.RoleService.page(this.q).then(rd=>{
                    this.q.total = rd.total;
                    this.tableData = rd.records;
                })
            },
            handleFilter() {
                this.query();
            },
            handleEdit(obj){
                this.$router.push({path: '/basic/role_grant', query: obj });
            },
            handleDelete(obj){
                this.$msg.confirm("确认删除?",()=>{
                    ss.RoleService.updateById({id:obj.id,delflag:0}).then(rd=>{
                        this.$msg.msgs("删除成功！");
                        this.query();
                    });
                })
            },
          handleRecover(obj){
            this.$msg.confirm("确认恢复?",()=>{
              ss.RoleService.updateById({id:obj.id,delflag:1}).then(rd=>{
                this.$msg.msgs("恢复成功！");
                this.query();
              });
            })
          },
            createdict(){
                this.dialogFormVisible = true;
                this.optflag = 'save'
            },
            save(){
                ss.RoleService.insert(this.f).then(rd=>{
                    this.$refs['form'].resetFields();
                    this.dialogFormVisible = false;
                    this.query();
                });
			}
        }
    }
</script>
